// extracted by mini-css-extract-plugin
export default {"importantBox":"importantBox-c153","bubbleContainer":"bubbleContainer-f9b9","next-button":"next-button-04d2"};